"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Immunization = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_date_1 = require("../Scalar/RTTI_date");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_Immunization_Performer_1 = require("./RTTI_Immunization_Performer");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
var RTTI_Immunization_Education_1 = require("./RTTI_Immunization_Education");
var RTTI_Immunization_Reaction_1 = require("./RTTI_Immunization_Reaction");
var RTTI_Immunization_ProtocolApplied_1 = require("./RTTI_Immunization_ProtocolApplied");
exports.RTTI_Immunization = t.recursion('IImmunization', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('Immunization'),
            vaccineCode: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            patient: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            status: RTTI_code_1.RTTI_code,
            _status: RTTI_Element_1.RTTI_Element,
            statusReason: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            encounter: RTTI_Reference_1.RTTI_Reference,
            occurrenceDateTime: t.string,
            _occurrenceDateTime: RTTI_Element_1.RTTI_Element,
            occurrenceString: t.string,
            _occurrenceString: RTTI_Element_1.RTTI_Element,
            recorded: RTTI_dateTime_1.RTTI_dateTime,
            _recorded: RTTI_Element_1.RTTI_Element,
            primarySource: t.boolean,
            _primarySource: RTTI_Element_1.RTTI_Element,
            reportOrigin: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            location: RTTI_Reference_1.RTTI_Reference,
            manufacturer: RTTI_Reference_1.RTTI_Reference,
            lotNumber: t.string,
            _lotNumber: RTTI_Element_1.RTTI_Element,
            expirationDate: RTTI_date_1.RTTI_date,
            _expirationDate: RTTI_Element_1.RTTI_Element,
            site: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            route: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            doseQuantity: RTTI_Quantity_1.RTTI_Quantity,
            performer: t.array(RTTI_Immunization_Performer_1.RTTI_Immunization_Performer),
            note: t.array(RTTI_Annotation_1.RTTI_Annotation),
            reasonCode: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            reasonReference: t.array(RTTI_Reference_1.RTTI_Reference),
            isSubpotent: t.boolean,
            _isSubpotent: RTTI_Element_1.RTTI_Element,
            subpotentReason: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            education: t.array(RTTI_Immunization_Education_1.RTTI_Immunization_Education),
            programEligibility: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            fundingSource: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            reaction: t.array(RTTI_Immunization_Reaction_1.RTTI_Immunization_Reaction),
            protocolApplied: t.array(RTTI_Immunization_ProtocolApplied_1.RTTI_Immunization_ProtocolApplied)
        })
    ]);
});
//# sourceMappingURL=RTTI_Immunization.js.map